import { Cancel as CancelIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/checkout-cancel')({
  component: CheckoutCancelPage,
});

function CheckoutCancelPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Paper 
          sx={{ 
            p: 6, 
            textAlign: 'center', 
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 8,
            bgcolor: 'background.paper',
          }}
        >
          <CancelIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 3, opacity: 0.5 }} />
          
          <Typography variant="h3" component="h1" gutterBottom fontWeight={800}>
            {t('pricing.checkoutCancelled')}
          </Typography>
          
          <Typography variant="h6" color="text.secondary" sx={{ mb: 4, fontWeight: 400 }}>
            {t('pricing.checkoutCancelledDesc')}
          </Typography>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              variant="outlined" 
              size="large" 
              fullWidth
              onClick={() => navigate({ to: '/pricing' })}
              sx={{ py: 1.5, fontWeight: 700 }}
            >
              {t('pricing.backToPlans')}
            </Button>
            
            <Button 
              variant="contained" 
              size="large" 
              fullWidth
              onClick={() => navigate({ to: '/' })}
              sx={{ 
                py: 1.5, 
                fontWeight: 700, 
                bgcolor: 'primary.main',
                '&:hover': { bgcolor: 'primary.dark' }
              }}
            >
              {t('pricing.goHome')}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
